import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackViewedJoinWorkspacePage = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedJoinWorkspacePage = useCallback(() => {
    track(`Viewed Join workspace page`);
  }, [track]);

  return { trackViewedJoinWorkspacePage };
};
